var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleQuoteSansRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oi:double-quote-sans-right",
    clipPath: "url(#clip0_20779_94679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.625 28.875L33 16.5L33 4.125L20.625 4.125L20.625 28.875ZM0 28.875L12.375 16.5L12.375 4.125L-2.16371e-06 4.125L0 28.875Z",
    fill: "#C1C1C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20779_94679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(33 33) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuoteSansRight);
export default __webpack_public_path__ + "static/media/double-quote-sans-right.5e15509ac6ae3f3d5a8f20c18e6926fa.svg";
export { ForwardRef as ReactComponent };